import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import { useState } from "react";
import { Copy, Check } from "lucide-react";
import "highlight.js/styles/github.css";

function CopyBtn({ text }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard?.writeText(text);
        setDone(true);
        setTimeout(() => setDone(false), 1500);
      }}
      className="absolute top-2 right-2 bg-slate-800/80 hover:bg-slate-900 text-white text-xs px-2 py-1 rounded flex items-center gap-1"
      data-testid="ai-copy-code"
    >
      {done ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      {done ? "Copié" : "Copier"}
    </button>
  );
}

export default function AiMarkdown({ children }) {
  const content = children || "";
  return (
    <div className="ai-markdown prose prose-sm max-w-none prose-slate prose-headings:font-semibold prose-headings:text-slate-900 prose-a:text-[#A88846] prose-strong:text-slate-900 prose-code:bg-slate-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-[0.85em] prose-code:before:content-none prose-code:after:content-none prose-table:text-sm">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          pre({ node, children, ...props }) {
            const codeText = String(
              node?.children?.[0]?.children?.[0]?.value || ""
            );
            return (
              <div className="relative my-3">
                <pre
                  {...props}
                  className="rounded-md bg-slate-900 text-slate-100 p-3 overflow-x-auto text-xs"
                >
                  {children}
                </pre>
                <CopyBtn text={codeText} />
              </div>
            );
          },
          table({ children }) {
            return (
              <div className="overflow-x-auto my-3">
                <table className="min-w-full border border-slate-200 text-sm">
                  {children}
                </table>
              </div>
            );
          },
          th({ children }) {
            return (
              <th className="border border-slate-200 bg-slate-50 px-2 py-1 text-left font-semibold">
                {children}
              </th>
            );
          },
          td({ children }) {
            return (
              <td className="border border-slate-200 px-2 py-1">{children}</td>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
